import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import IAmClient from './pages/IAmClient';
import IAmProfessional from './pages/IAmProfessional';
import PublishProject from './pages/PublishProject';
import ProjectDetails from './pages/ProjectDetails';
import CumFunctioneaza from './pages/CumFunctioneaza';
import Autentificare from './pages/Autentificare';
import Register from './pages/Register';

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route path="/i-am-client" element={<IAmClient />} />
            <Route path="/i-am-professional" element={<IAmProfessional />} />
            <Route path="/publish-project" element={<PublishProject />} />
            <Route path="/cum-functioneaza" element={<CumFunctioneaza />} />
            <Route path="/autentificare" element={<Autentificare />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
